import React from "react";

export const schema = {
        title: "",
        description: "",
        type: "object",
        //required: ["title"],
        properties: {
            deadlift: {type: "integer", title: "", default: ""},
            back_squat: {type: "integer", title: "", default: ""},
            front_squat: {type: "integer", title: "", default: ""},
            hex_bar_deadlift: {type: "integer", title: "", default: ""},
            bench_press: {type: "integer", title: "", default: ""},
            bent_over_row: {type: "integer", title: "", default: ""},
            clean: {type: "integer", title: "", default: ""},
            overhead_squat: {type: "integer", title: "", default: ""},
            snatch: {type: "integer", title: "", default: ""},
            jerk: {type: "integer", title: "", default: ""},
            pull_up: {type: "integer", title: "", default: ""}
        }
}

export const uiSchema = {

    deadlift: {
        "ui:title": "Deadlift",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    },
    back_squat: {
        "ui:title": "Back Squat",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    },
    front_squat: {
        "ui:widget": "updown",
        "ui:title": "Front Squat",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    },
    hex_bar_deadlift: {
        "ui:widget": "updown",
        "ui:title": "Hex Bar Deadlift",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    },
    bench_press: {
        "ui:widget": "updown",
        "ui:title": "Bench Press",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    },
    bent_over_row: {
        "ui:widget": "updown",
        "ui:title": "Bent Over Row",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    },
    clean: {
        "ui:widget": "updown",
        "ui:title": "Clean",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    },
    overhead_squat: {
        "ui:widget": "updown",
        "ui:title": "Overhead Squat",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    },
    snatch: {
        "ui:widget": "updown",
        "ui:title": "Snatch",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    },
    jerk: {
        "ui:widget": "updown",
        "ui:title": "Jerk",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    },
    pull_up: {
        "ui:widget": "updown",
        "ui:title": "Pull-up",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Enter pounds.",
        "ui:placeholder": "0"
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/schema/Strength.js